// This file is AUTOGENERATED, do not edit it manually!!!

export const activityList = {
    Activities: '1#Activity#Activities',
    Activities_Text: '1#{0} Activity#{0} Activities',
    activities_without_dates: 'Activities without dates',
    Activity: 'Activity',
    Activity_Billing: 'Billable',
    Activity_Cost: 'Activity Billable',
    Activity_CostVariance: 'Cost Variance',
    Activity_HoursLeft: 'left',
    Activity_InternalCost: 'Actual Cost',
    Activity_Profit: 'Profit',
    Add_Task: 'Add task',
    AITaskGeneration_projectName: 'Name',
    AITaskGeneration_retry: 'Retry',
    AITaskGeneration_title: 'Create project plan with AI',
    All_Saved_Views: 'All saved views',
    Apply_Text: 'Apply',
    apply_wbs_sorting: 'Apply WBS sorting',
    Archive_Success_Message: 'The project \"{0}\" has been archived',
    archived_label: '(archived)',
    Baseline_Text: 'Baseline',
    Board_CreateTaskInProjectPlaceholder: 'Create in project',
    Board_ShowMore: 'Show more',
    Browse_Views: 'Browse views',
    Budget_problem_project: 'Actual Cost exceeds Total Budget',
    Budget_problem_task: 'Actual Labor Cost exceeds Total Budget',
    Budget_Text: 'Budget',
    Budget_warning_project: 'EAC Cost exceeds Total Budget',
    Budget_warning_task: 'EAC Labor Cost exceeds Total Budget',
    By_Text: 'by',
    change_activity_type_to_label: 'Change activity type to',
    ChooseTemplateDropdownLabel: 'Create a project based on an existing template',
    Counter: 'Projects/Activities counter',
    CPI_Problem: 'CPI is below the threshold',
    Create: 'Create',
    create_snapshot: 'Project snapshots',
    CreateNewItem: 'Type here to create a new project or activity...',
    CreateProject_Tooltip: 'Create a new project',
    CriticalPath_Text: 'Critical path',
    CustomField_No: 'No',
    CustomField_Yes: 'Yes',
    DayPluralFormat: '1#Day#Days',
    Default_Text: 'Default',
    Delete_Confirmation_Title: 'Delete these objects?',
    Delete_Entity_Confirmation_Archive_Description: '<b>Instead, you can also archive the project data and restore it as required.</b>',
    Delete_Project_Title: 'Delete project \"{0}\" (ID {1})?',
    Delete_Task_Title: 'Delete activity \"{0}\" (ID {1})?',
    Delete_Text: 'Delete',
    DeleteEntityConfirmation: 'including all timelogs, messages and attached files {0}. The action cannot be undone!',
    DeletePermanently: 'Delete permanently',
    DeleteVerb: '1#will be permanently deleted#will be permanently deleted',
    DeleteVerbActivity: '1#will be permanently deleted#will be permanently deleted',
    Dependency_AddMore_Text: 'Add more dependencies',
    Dependency_Cancel: 'Cancel',
    Dependency_Choose: 'Select activity or type a keyword... ',
    Dependency_days: 'days',
    Dependency_DelayWarningExample: 'Example: -34, 42',
    Dependency_DelayWarningText: 'Enter numbers from -1000 to 1000',
    Dependency_DependencyCycle: 'Sorry, the dependency can\'t be created because the selected activity creates a dependency loop.',
    Dependency_DependencyType_Text: 'Dependency type',
    Dependency_DependsOn_Text: 'Depends on',
    Dependency_FinishToStart_Minus1: 'Activity starts the day before {0} finishes',
    Dependency_FinishToStart_Minus1_Pattern: 'Activity starts <b>the day before</b> \"{0}\" finishes',
    Dependency_FinishToStart_Minus2: 'Activity starts {1} before {0} finishes',
    Dependency_FinishToStart_Minus2_Pattern: 'Activity starts <b>{1} before</b> \"{0}\" finishes',
    Dependency_FinishToStart_Plus0: 'Activity starts the day {0} finishes',
    Dependency_FinishToStart_Plus0_Pattern: 'Activity starts <b>the day</b> \"{0}\" finishes',
    Dependency_FinishToStart_Plus1: 'Activity starts the day after {0} finishes',
    Dependency_FinishToStart_Plus1_Pattern: 'Activity starts <b>the day after</b> \"{0}\" finishes',
    Dependency_FinishToStart_Plus2: 'Activity starts {1} after {0} finishes',
    Dependency_FinishToStart_Plus2_Pattern: 'Activity starts <b>{1} after</b> \"{0}\" finishes',
    Dependency_FinishWhenStarted_Text: 'Activity finished when \"{0}\" is started',
    Dependency_FinishWhenStarted_Title: 'Start to Finish',
    Dependency_Lag_Text: 'Lag',
    Dependency_ParentChildRelationship: 'Sorry, the dependency can\'t be created because one of the activities is a parent and another one is its child (sub-activity).',
    Dependency_Reason: 'Reason',
    Dependency_Remove_Text: 'Remove',
    Dependency_RemoveSingleDependency_Text: 'Remove dependency',
    Dependency_Save: 'Save',
    Dependency_SelectDependsOn_Text: 'Select Depends on',
    Dependency_StartsWhenFinished_Text: 'Activity starts when \"{0}\" is finished',
    Dependency_StartsWhenFinished_Title: 'Finish to Start',
    Dependency_StartsWhenStarted_Text: 'Activity starts when \"{0}\" is started',
    Dependency_StartsWhenStarted_Title: 'Start to Start',
    Dependency_StartToFinish_Minus1: 'Activity finishes the day before {0} starts',
    Dependency_StartToFinish_Minus1_Pattern: 'Activity finishes <b>the day before</b> \"{0}\" starts',
    Dependency_StartToFinish_Minus2: 'Activity finishes {1} before {0} starts',
    Dependency_StartToFinish_Minus2_Pattern: 'Activity finishes <b>{1} before</b> \"{0}\" starts',
    Dependency_StartToFinish_Plus0: 'Activity finishes the day {0} starts',
    Dependency_StartToFinish_Plus0_Pattern: 'Activity finishes <b>the day</b> \"{0}\" starts',
    Dependency_StartToFinish_Plus1: 'Activity finishes the day after {0} starts',
    Dependency_StartToFinish_Plus1_Pattern: 'Activity finishes <b>the day after</b> \"{0}\" starts',
    Dependency_StartToFinish_Plus2: 'Activity finishes {1} after {0} starts',
    Dependency_StartToFinish_Plus2_Pattern: 'Activity finishes <b>{1} after</b> \"{0}\" starts',
    Dependency_StartToStart_Minus1: 'Activity starts the day before {0} starts',
    Dependency_StartToStart_Minus1_Pattern: 'Activity starts <b>the day before</b> \"{0}\" starts',
    Dependency_StartToStart_Minus2: 'Activity starts {1} before {0} starts',
    Dependency_StartToStart_Minus2_Pattern: 'Activity starts <b>{1} before</b> \"{0}\" starts',
    Dependency_StartToStart_Plus0: 'Activity starts the day {0} starts',
    Dependency_StartToStart_Plus0_Pattern: 'Activity starts <b>the day</b> \"{0}\" starts',
    Dependency_StartToStart_Plus1: 'Activity starts the day after {0} starts',
    Dependency_StartToStart_Plus1_Pattern: 'Activity starts <b>the day after</b> \"{0}\" starts',
    Dependency_StartToStart_Plus2: 'Activity starts {1} after {0} starts',
    Dependency_StartToStart_Plus2_Pattern: 'Activity starts <b>{1} after</b> \"{0}\" starts',
    Dependency_Warning_Text: 'The operation could not be completed. ',
    Details: 'Details',
    Edit_Text: 'Edit',
    empty_sorting_list: 'No sorting options found',
    EnterProjectName: 'Enter project name',
    EnterTaskName: 'Enter task name',
    EnterViewName_Text: 'Enter view name',
    Error_DragAndDrop_BreakingHierarchy: 'An activity cannot be a child of its own sub-activity.',
    Error_DragAndDrop_ChangeParentInFlattenView: 'Please change the flat view to hierarchical to change activities hierarchy.',
    Error_DragAndDrop_CycleDependencies: 'This operation will create a cyclic dependency (e.g. Task A depends on Task B, Task B depends on Task A).',
    Error_DragAndDrop_DifferentProjects: 'You cannot move an activity to another project (use activity details).',
    Error_DragAndDrop_ReorderWithSorting: 'For activities reordering, WBS ascending sorting should be applied.',
    Error_PresetNotFound: 'The selected view has been deleted or unshared. To continue, refresh the page.',
    EstimatedHours_problem: 'Actual hours exceed Estimated hours',
    export_activities: 'Activities',
    export_activities_expanded_only: 'Activities (expanded only)',
    Export_Activities_Text: 'Export Activities to CSV',
    Export_Import_Text: 'Export & Import',
    export_projects: 'Projects',
    Export_Projects_Text: 'Export Projects to CSV',
    flat_view: 'Flat view',
    From: 'from',
    Group_By_Portfolio: 'Group by portfolio',
    group_by_project: 'Group by project',
    Hide_Counter: 'Hide Projects/Activities counter',
    Hide_Text: 'Hide',
    hide_uncategorized_tasks: 'Hide activities not matching any calendar',
    Hours_Short_Text: 'h',
    Import_CSV_Text: 'Import from CSV',
    Import_MSProject_Text: 'Import from MS Project',
    Import_Text: 'Import',
    Indicator_Counter_Snooze_Tooltip: '1#{0} item has troubles#{0} items have troubles',
    Indicator_Counter_Tooltip: 'Number of activities at risk',
    Indicator_Project_Tooltip: 'The project needs attention at:',
    Indicator_Snooze_1_Week: 'For 1 week',
    Indicator_Snooze_4_Hours: 'For 4 hours',
    Indicator_Snooze_Cancel: 'Cancel snooze',
    Indicator_Snooze_Custom: 'Custom',
    Indicator_Snooze_Custom_Modal_Header: 'Snooze indication',
    Indicator_Snooze_Forever: 'Forever',
    Indicator_Snooze_Menu_Text: 'Snooze trouble indication',
    Indicator_Snooze_Message: 'Trouble indication snoozed for you till {0}.',
    Indicator_Snooze_Message_Forever: 'Trouble indication snoozed for you forever.',
    Indicator_Snooze_Until_Tomorrow: 'Until tomorrow',
    Indicator_Task_Tooltip: 'The activity needs attention at:',
    Learn_More_Text: 'Learn more',
    Loading_Text: 'Loading...',
    More_Tasks: '{0} more',
    MoreActions_AddActivity: 'Add activity',
    MoreActions_AddAIActivities: 'Create project plan with AI',
    MoreActions_AddNextActivity: 'Add next activity',
    MoreActions_AddSubActivity: 'Add sub-activity',
    MoreActions_SaveProjectAsTemplate: 'Save as template',
    MoreActions_SetAsMilestone: 'Set as milestone',
    MoreActions_UnsetAsMilestone: 'Unset as milestone',
    My_Presets: 'My views',
    My_Text: ' Me',
    MyPresetName_Text: 'Mine',
    NewProject: 'New project',
    NewProjectBasedOn: 'New project based on {0}',
    NewTask: 'New Task',
    no_custom_field_value_label: 'n/a',
    No_Portfolio: 'Without Portfolio',
    no_project_custom_fields_created_text: 'No project custom fields created',
    No_Templates_Text: 'No templates found.',
    NoSavedViews_Text: 'No saved views.',
    Of: 'of',
    old_sort_az: 'A→Z',
    old_sort_za: 'Z→A',
    parent_activities: 'Parent activities',
    Portfolios_Text: '1#{0} Portfolio#{0} Portfolios',
    preset_delete: 'Delete view',
    preset_delete_confirmation: 'Delete saved view \"{0}\"?',
    preset_rename: 'Rename view',
    preset_save: 'Save view',
    preset_saveAs: 'Save view as',
    preset_share: 'Share with everyone in this space',
    preset_unshare_confirmation: 'Unshare view {0}?',
    Project: 'Project',
    Project_ActualBudgetProfitability: 'Actual Budget Profitability',
    Project_BudgetedCost: 'Total Project Budget',
    Project_CostVariance: 'Cost Variance',
    Project_EstimatedBudgetProfitability: 'Estimated Budget Profitability',
    Project_Expenses: 'Expenses',
    project_info: 'Project info',
    Project_InternalCost: 'Actual Cost',
    Project_ProjectBilling: 'Project Billable',
    Project_ProjectProfit: 'Project Profit',
    Project_ProjectProfitability: 'Profitability',
    ProjectArchive: 'Project (archived)',
    ProjectEndDate_problem: 'The project was not completed on the due date',
    Projects: '1#Project#Projects',
    Projects_Text: '1#{0} Project#{0} Projects',
    Rename_Text: 'Rename',
    Restore_Text: 'Restore',
    Save_Text: 'Save',
    SaveAs_Text: 'Save as',
    Share_Text: 'Share',
    Shared_With_Me: 'Shared with me',
    show_archived_projects: 'Show archived projects',
    Show_Text: 'Show',
    SortBy_Text: 'Sort by',
    SPI_Problem: 'SPI is below the threshold',
    SubActivities: '1#Sub-activity#Sub-activities',
    switchToClassicUI: 'Switch to Old UI',
    switchToNewUI: 'Switch to New UI',
    tab_Board: 'Board',
    tab_Calendar: 'Calendar',
    tab_Gantt: 'Gantt',
    tab_Table: 'Table',
    TargetProfit_warning: 'Target Profit less than Expected Profit',
    TargetProfitPercentage_warning: 'Target Profit (%) less than Expected Profit (%)',
    TaskEndDate_problem: 'The task was not completed on the due date',
    TaskEndDate_warning: 'The task ends later than its parent',
    TaskStartDate_warning: 'The task starts earlier than its parent',
    Templates_Popup_Title: 'Based on Template:',
    TimerText: '1#{0} second#{0} seconds',
    Tools_Menu_Text: 'Tools',
    Tooltip_DefaultPresetIcon: 'Select or manage saved views',
    Tooltip_RevertToDefaultPreset: 'Revert to default view',
    Tooltip_SaveDefaultPreset: 'Save your current layout and filters as a View',
    Tooltip_SharedByMePreset: 'Shared by me',
    TotalTargetRevenue_warning: 'EAC Billable less than Total Target Revenue',
    Unarchive_Success_Message: 'Project \"{0}\" was unarchived.',
    uncategorized_tasks: 'Activities without calendars',
    Unshare_Text: 'Unshare',
    View_Project_Link: 'View project',
    WBSNumber_Text: 'WBS',
    what_to_export: 'What to export?',
};
